module.exports = __webpack_public_path__ + "img/game.c56f67a0.svg";